import React, { useState } from 'react';
import ThreeDBook from './ThreeDBook';
import './Bookshelf.css';

function Bookshelf({ books }) {
  const [selectedBook, setSelectedBook] = useState(null);

  return (
    <div className="bookshelf-container">
      {!selectedBook ? (
        <div className="bookshelf">
          {books.map(book => (
            <div 
              key={book.id} 
              className="book-on-shelf" 
              onClick={() => setSelectedBook(book)}
            >
              <div className="book-spine-shelf">{book.title}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className="book-reader">
          <button 
            className="close-reader" 
            onClick={() => setSelectedBook(null)}
          >
            Back to Shelf
          </button>
          <ThreeDBook book={selectedBook} />
        </div>
      )}
    </div>
  );
}

export default Bookshelf;
